module.exports = __webpack_public_path__ + "img/repeat.af9146f3.svg";